"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RTESubHeading = exports.RTEHeading = exports.InteriorPageSubHeading = exports.InteriorPageHeadingCentered = exports.InteriorPageHeading = exports.CardHeading = void 0;
var _theme = _interopRequireDefault(require("./../../scss/theme.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  HeadingReset = {
    display: "block",
    margin: "0 0 2rem",
    padding: "0",
    "* + &": {
      marginTop: "4rem"
    },
    "&:last-child": {
      marginBottom: "0"
    }
  },
  InteriorPageHeading = () => {
    return {
      base: {
        ...HeadingReset,
        fontFamily: _theme.default.heading_InteriorPageHeading_font_family,
        lineHeight: _theme.default.heading_InteriorPageHeading_line_height
      },
      caption: {},
      content: {
        fontFamily: _theme.default.heading_InteriorPageHeading_font_family,
        fontSize: _theme.default.heading_InteriorPageHeading_font_size,
        fontWeight: _theme.default.heading_InteriorPageHeading_font_weight,
        letterSpacing: _theme.default.heading_InteriorPageHeading_letter_spacing,
        lineHeight: _theme.default.heading_InteriorPageHeading_line_height,
        textTransform: _theme.default.heading_InteriorPageHeading_text_transform
      }
    };
  },
  InteriorPageHeadingCentered = () => {
    const Interior = merge({}, InteriorPageHeading());
    return {
      base: merge(Interior.base, {
        color: "#FFFFFF",
        textAlign: _theme.default.heading_InteriorSubPageHeading_text_align
      }),
      caption: merge(Interior.caption, {
        textAlign: _theme.default.heading_InteriorSubPageHeading_caption_text_align
      }),
      content: merge(Interior.content, {
        textAlign: _theme.default.heading_InteriorSubPageHeading_text_align
      })
    };
  },
  InteriorPageSubHeading = () => {
    return {
      base: {
        ...HeadingReset,
        lineHeight: _theme.default.heading_InteriorSubPageHeading_line_height,
        textAlign: _theme.default.heading_InteriorSubPageHeading_text_align
      },
      caption: {
        color: _theme.default.heading_InteriorSubPageHeading_caption_color,
        display: _theme.default.heading_InteriorSubPageHeading_caption_display,
        fontFamily: _theme.default.heading_InteriorSubPageHeading_caption_font_family,
        fontSize: _theme.default.heading_InteriorSubPageHeading_caption_font_size,
        fontWeight: _theme.default.heading_InteriorSubPageHeading_caption_font_weight,
        letterSpacing: _theme.default.heading_InteriorSubPageHeading_caption_letter_spacing,
        lineHeight: _theme.default.heading_InteriorSubPageHeading_caption_line_height,
        textAlign: _theme.default.heading_InteriorSubPageHeading_caption_text_align,
        textTransform: _theme.default.heading_InteriorSubPageHeading_caption_text_transform
      },
      content: {
        color: _theme.default.heading_InteriorSubPageHeading_color,
        fontFamily: _theme.default.heading_InteriorSubPageHeading_font_family,
        fontSize: _theme.default.heading_InteriorSubPageHeading_font_size,
        lineHeight: _theme.default.heading_InteriorSubPageHeading_line_height,
        textAlign: _theme.default.heading_InteriorSubPageHeading_text_align
      }
    };
  },
  CardHeading = () => {
    return {
      base: {
        ...HeadingReset
      },
      caption: {
        display: "none"
      },
      content: {
        color: _theme.default.heading_CardHeading_color,
        fontFamily: _theme.default.heading_CardHeading_font_family,
        fontSize: _theme.default.heading_CardHeading_font_size,
        fontWeight: _theme.default.heading_CardHeading_font_weight,
        lineHeight: _theme.default.heading_CardHeading_line_height
      }
    };
  },
  RTEHeading = () => {
    return {
      base: {
        ...HeadingReset,
        color: _theme.default.heading_RTEHeading_color
      },
      caption: {
        display: "none"
      },
      content: {
        color: _theme.default.heading_RTEHeading_color,
        fontFamily: _theme.default.heading_RTEHeading_font_family,
        fontSize: _theme.default.heading_RTEHeading_font_size,
        fontWeight: _theme.default.heading_RTEHeading_font_weight,
        lineHeight: _theme.default.heading_RTEHeading_line_height
      }
    };
  },
  RTESubHeading = () => {
    return {
      base: {
        ...HeadingReset
      },
      caption: {
        display: "none"
      },
      content: {
        fontFamily: _theme.default.heading_RTESubHeading_font_family,
        fontSize: _theme.default.heading_RTESubHeading_font_size,
        fontWeight: _theme.default.heading_RTESubHeading_font_weight
      }
    };
  };
exports.RTESubHeading = RTESubHeading;
exports.RTEHeading = RTEHeading;
exports.CardHeading = CardHeading;
exports.InteriorPageSubHeading = InteriorPageSubHeading;
exports.InteriorPageHeadingCentered = InteriorPageHeadingCentered;
exports.InteriorPageHeading = InteriorPageHeading;